/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EmailManagementControllerSendEvaluationResultsNotificationRequest { 
    /**
     * ID de la compañía
     */
    companyId: string;
    /**
     * ID del periodo de evaluación (opcional)
     */
    periodId?: string;
    /**
     * URL base para ver resultados (opcional, default: https://www.comunidadavalanz.com.mx)
     */
    resultsBaseUrl?: string;
    /**
     * URL del logo de la empresa (opcional)
     */
    logoUrl?: string;
}

